// © Microsoft Corporation. All rights reserved.

import { Comment } from "@msnews/social-data-service";

export function commentExists(commentList: Array<Comment>, commentId) {
    return commentList && commentList.find(comment => {
        return comment.id === commentId || (comment.replies && comment.replies.find(reply => {
            return reply.id === commentId;
        }));
    });
}